import http from "./../helpers/http";

export const postSensorMessage = (payload) => {
  return http.post("/", payload);
};
